import * as React from 'react';
/**
 *
 * Original name: image
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A372
 *
 */
export const ImagePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M11 11v42h42V11H11Zm38 4v12.328a10.006 10.006 0 0 0-13.071.915l-8.515 8.515a2 2 0 0 1-2.829 0l-2.343-2.343A5.992 5.992 0 0 0 15 33.488V15h34ZM15 49V38.828l1.585-1.585a2 2 0 0 1 2.829 0l2.343 2.343a6.006 6.006 0 0 0 8.485 0l8.515-8.515a6.008 6.008 0 0 1 8.485 0L49 32.828V49H15Z", fill: "currentColor" }),
    React.createElement("path", { d: "M25.5 30a4.18 4.18 0 0 0 4.5-4.5 4.18 4.18 0 0 0-4.5-4.5 4.18 4.18 0 0 0-4.5 4.5 4.18 4.18 0 0 0 4.5 4.5Z", fill: "currentColor" })));
